export default __webpack_public_path__ + "static/business-reservations-496e881a0379da05385f272eed884b05.webp";